"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    videoWidth: {
      margin: '0 0 32px 0',
      width: '100%',
      maxWidth: '640px',
      outline: 'none'
    },
    videoHeight: {
      position: 'relative',
      height: 0,
      maxHeight: '360px',
      paddingBottom: '56.25%'
    },
    videoEmbed: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      maxHeight: '360px',
      backgroundColor: theme.palette.common.black,
      objectFit: 'contain',
      outline: 'none'
    }
  };
});
var VideoEditConfig = {
  emptyLabel: 'Configure a Video',
  isEmpty: function isEmpty(props) {
    if (props.videoPath || props.posterImage) {
      return false;
    } else {
      return true;
    }
  }
};
var fullScreenOnMobile = function fullScreenOnMobile(e) {
  var isMobile = window.outerWidth <= 500;
  if (isMobile) {
    if (e.target.requestFullscreen) {
      e.target.requestFullscreen();
    } else if (e.target.mozRequestFullScreen) {
      /* Firefox */
      e.target.mozRequestFullScreen();
    } else if (e.target.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      e.target.webkitRequestFullscreen();
    } else if (e.target.msRequestFullscreen) {
      /* IE/Edge */
      e.target.msRequestFullscreen();
    }
  }
};
var Video = function Video(_ref) {
  var videoPath = _ref.videoPath,
    posterImage = _ref.posterImage,
    anchorId = _ref.anchorId,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? '16:9' : _ref$aspectRatio;
  var classes = useStyles();
  return videoPath || posterImage ? __jsx("div", {
    id: anchorId,
    className: "aem-ms-video-player ".concat(classes.videoWidth, " aspect-ratio-").concat(aspectRatio.replace(/:/g, '-'))
  }, __jsx("div", {
    className: "".concat(classes.videoHeight)
  }, __jsx("video", {
    className: "".concat(classes.videoEmbed),
    poster: posterImage,
    style: {
      cursor: 'pointer'
    },
    controls: true,
    controlsList: "nodownload",
    width: "100%",
    height: "auto",
    onTouchEnd: function onTouchEnd(e) {
      return fullScreenOnMobile(e);
    },
    preload: "none"
  }, __jsx("source", {
    src: videoPath
  })))) : null;
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/video')(Video, VideoEditConfig);
exports.default = _default;